<header class="tk-header__wrapper">
  <section class="app-header__logo tk-header__logo tk-header__section">
    <a class="tk-link" routerLink="/">
      <span class="tk-logo" title="Информационная система «Мигрант»"></span>
    </a>
  </section>

  <section class="app-header__caption tk-header__caption tk-header__section">
    <span class="tk-text tk-title">{{ 'sys_name.part_1' | localize }}</span>

    <span class="tk-text">{{ 'sys_name.part_2' | localize }}</span>
  </section>

  <!--<section class="app-header__menu tk-header__content tk-header__section">-->
  <!--  <tk-main-menu [deep]="false"></tk-main-menu>-->
  <!--</section>-->

  <section class="app-header__user tk-header__user tk-header__section">
    <kendo-dropdownlist
      *ngIf="isPublic"
      class="langSelector"
      fillMode="flat"
      [data]="languages"
      [(ngModel)]="selectedLang"
      (valueChange)="valueChange($event)"
    ></kendo-dropdownlist>
    <tk-user-panel></tk-user-panel>
  </section>
</header>
